module.exports = __webpack_public_path__ + "static/media/bg-login2.5ef53c01.png";